import React from 'react'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

type ConfirmButtonProps = {
  text: string
  isDisabled?: boolean
  isLoading?: boolean
  onClick: () => void
  isLoadingButton?: boolean
  autoFocus?: boolean
}

const ConfirmButton = ({
  text,
  isDisabled,
  isLoading,
  onClick,
  isLoadingButton = false,
  autoFocus = true,
}: ConfirmButtonProps) => {
  const ButtonComponent = isLoadingButton ? LoadingButton : Button

  return (
    <ButtonComponent
      onClick={onClick}
      size="small"
      autoFocus={autoFocus}
      variant="contained"
      disabled={isDisabled}
      aria-label={text}
      {...(isLoadingButton && { loading: isLoading })} 
    >
      {text}
    </ButtonComponent>
  )
}

export default ConfirmButton
